__turbopack_context__.v({
  "fadeOnHover": "styles-module__dSu21W__fadeOnHover",
  "fadeOverlay": "styles-module__dSu21W__fadeOverlay",
  "label": "styles-module__dSu21W__label",
  "labelSelected": "styles-module__dSu21W__labelSelected",
  "radioIndicator": "styles-module__dSu21W__radioIndicator",
  "radioIndicatorError": "styles-module__dSu21W__radioIndicatorError",
  "radioIndicatorSelected": "styles-module__dSu21W__radioIndicatorSelected",
});
